/*
 *@author   tonicli
 *@date     2016/9/16
 */
import { globalObject } from './system';
import { buildUrl } from './url';

const protocol = /^(http|https):$/.test(globalObject.location?.protocol) ? globalObject.location?.protocol : 'https:';
const bossUrl = `${protocol}//btrace.qq.com/kvcollect`;
const boss2attaUrl = `${protocol}//h.trace.qq.com/bosskv`;
const attaUrl = `${protocol}//h.trace.qq.com/kv`;
const bossIdPattern = /^[1-9]\d{2,5}$/;
const boss2attaIdPattern = /^(z|Z)/;

function _handle() {}

function _isObject(value) {
  const type = typeof value;
  return !!value && (type === 'object' || type === 'function');
}

function _mapValues(obj, iter) {
  if (!_isObject(obj)) {
    return obj;
  }

  const retObj = {};
  Object.keys(obj).forEach((p) => {
    retObj[p] = iter(obj[p]);
  });
  return retObj;
}

function _encodeDollor(content, useAtta = false) {
  if (typeof content !== 'string') {
    return content;
  }
  const replacement = useAtta ? '\\$' : '|||';
  return content.replace(/\$/g, replacement);
}

export default class Boss {
  /**
   *
   * @param {Object} cfg - {bossId: xxx, pwd: xxx}或者{attaId: xxx, token: xxx}
   * @param {string|number} [cfg.bossId] - boss系统分配的bossid
   * @param {string|number} [cfg.pwd] - boss系统分配的pwd
   * @param {string|number} [cfg.attaId] - atta系统分配的AttaID
   * @param {string|number} [cfg.token] - atta系统分配的Token
   * @param {boolean} [cfg.useAtta] - 是否强制走atta上报
   */
  constructor(cfg) {
    if (!cfg || (
      (!cfg.bossId || (!cfg.pwd && parseInt(cfg.pwd, 10) !== 0))
      && (!cfg.attaId || !cfg.token)
    )) {
      throw new Error('[vft-common.Boss]config中缺少{bossId, pwd}或者{attaId, token}');
    }
    this._cfg = cfg;
    const { useAtta, url, ...params } = this.normalizeConfig(cfg);
    this.useAtta = useAtta;
    this._baseUrl = buildUrl(cfg.baseUrl || url, params);
  }

  normalizeConfig(config) {
    const { useAtta, bossId, pwd, attaId, token } = config;

    if (!useAtta && bossIdPattern.test(bossId)) {
      return {
        useAtta: false,
        url: bossUrl,
        BossId: bossId,
        Pwd: pwd,
      };
    }

    const params = {
      useAtta: true,
      attaid: attaId || bossId,
      token: token || pwd,
    };
    params.url = boss2attaIdPattern.test(params.attaid) ? boss2attaUrl : attaUrl;

    return params;
  }
  report(params) {
    this._doReport(this.buildReportUrl(params));
    return this;
  }
  buildReportUrl(params) {
    const url = buildUrl(
      this._baseUrl,
      _mapValues(params, (v) => {
        if (_isObject(v)) {
          try {
            v = JSON.stringify(v);
          } catch (e) {
          }
        }
        return _encodeDollor(v, this.useAtta);
      }),
      true,
    );
    return _encodeDollor(url, this.useAtta);
  }
  setBaseUrl(url) {
    this._baseUrl = url;
    return this;
  }
  getBaseUrl() {
    return this._baseUrl;
  }
  _doReport(url) {
    // 临时处理，非浏览器环境不上报
    if (!globalObject.document) return this;

    const reportObject = document.createElement('img');
    reportObject.onerror = _handle;
    reportObject.onload = _handle;
    reportObject.onabort = _handle;
    reportObject.src = url;

    return this;
  }
  _encodeDollor(content, useAtta) {
    return _encodeDollor(content, useAtta);
  }
}
